import { render } from "./project-detail.vue?vue&type=template&id=38a316bc&scoped=true"
import script from "./project-detail.vue?vue&type=script&lang=js"
export * from "./project-detail.vue?vue&type=script&lang=js"

import "./project-detail.vue?vue&type=style&index=0&id=38a316bc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a316bc"]])

export default __exports__